<template>
  <div>
    <Header></Header>
    <Aside class="aside"></Aside>
    <Main class="main"></Main>
  </div>
</template>

<script>
import Header from "./Header";
import Aside from "./Aside";
import Main from "./Main";

export default {
  components: {
    Header: Header,
    Aside: Aside,
    Main: Main,
  },
};
</script>

<style lang="scss" scoped>
.aside {
  top: 60px; /* header的高度 */
}

.main {
  padding-top: 60px + 20px; /* header的高度再加一点儿间隙 */
  margin-left: 300px + 20px; /* aside的宽度再加一点儿间隙 */
}
</style>